import React from "react";
import moment from "moment";
import { Formik } from 'formik';
import * as Yup from 'yup';
// import { registerUser } from "../_actions/user_actions";
import { useDispatch } from "react-redux";
import { Form, Typography} from 'antd';


function AuthPage(props) {


  
};


export default AuthPage
